import { render, staticRenderFns } from "./group-detail.vue?vue&type=template&id=28d08a8e&scoped=true"
import script from "./group-detail.vue?vue&type=script&lang=js"
export * from "./group-detail.vue?vue&type=script&lang=js"
import style0 from "./group-detail.vue?vue&type=style&index=0&id=28d08a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d08a8e",
  null
  
)

export default component.exports